const HOUR_MS = 60 * 60 * 1000;

/**
 * Whether self-serve appointment management is inside its fixed 24-hour guard.
 * This is intentionally independent of the tenant's multiple-booking setting:
 * that setting controls whether another appointment may be booked, not whether
 * the just-created appointment may be cancelled or rescheduled.
 */
export function isWithinAppointmentManagementGuard(
  appointmentStart: Date | string,
  now: number = Date.now(),
): boolean {
  return new Date(appointmentStart).getTime() - now <= 24 * HOUR_MS;
}
